import { render } from "./HeroiconsSolidTerminal.vue?vue&type=template&id=5e9c0bc0"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidTerminal.vue"]])

export default __exports__